import { UserAdminTab, UserAdminTabType } from './types';

export const UserAdminTabList: UserAdminTab[] = [
  { label: `Edit Users`, value: UserAdminTabType.EDIT_USERS },
  { label: `Roles`, value: UserAdminTabType.CUSTOMIZE_ROLES },
  { label: `Change Permissions`, value: UserAdminTabType.CHANGE_PERMISSIONS },
];
